export default __webpack_public_path__ + "static/media/AgriDigital_Lockup_Horizontal_Colour.a6d67fc5.svg";